import React from "react";

interface IProps {
  status?: string;
  statusKeys?: {
    pending: string;
    cancel: string;
    complete: string;
    delivered : string;
  };
}

const PrintStatus = ({
  status,
  statusKeys = {
    cancel: "cancelled",
    pending: "pending",
    complete: "completed",
    delivered : "delivered"
  },
}: IProps) => {
  let pendingClass = "bg-[#F2A90024] text-[#F2A900]";
  let cancelClass = "bg-[#FFCBCB] text-[#FF0030]";
  let completeClass = "bg-[#4ac24224] text-[#4ac242]";
  let dileveredClass = "bg-[#a4c3f524] text-[#3b82f5]";

  const getStatusClass = (status: string) => {
    switch (status) {
      case statusKeys.pending:
        return pendingClass;
      case statusKeys.cancel:
        return cancelClass;
      case statusKeys.complete:
        return completeClass;
      case statusKeys.delivered:
        return dileveredClass;
      default:
        return "";
    }
  };
  return (
    <div
      className={`px-3 py-1 rounded font-size-15px font-Poppins-Medium h-fit lowercase first-letter:capitalize ${getStatusClass(
        status || ""
      )}`}
    >
      {status}
    </div>
  );
};

export default PrintStatus;
